// Do not insert custom values to the colors or breakpoints Vuestic UI config
// or they will be overwritten! Use Tailwind CSS config instead.

import { createIconsConfig } from 'vuestic-ui'

const iconsConfig = createIconsConfig({
	aliases: [
		{ name: 'va-arrow-down', to: 'expand_more' },
		{ name: 'va-arrow-up', to: 'expand_less' },
		{ name: 'va-calendar', to: 'calendar_today' },
		{ name: 'va-check', to: 'check' },
		{ name: 'va-clear', to: 'cancel' },
		{ name: 'va-close', to: 'close' },
		{ name: 'va-delete', to: 'delete' },
		{ name: 'va-loading', to: 'sync' },
		{ name: 'va-warning', to: 'warning' },
	],
	fonts: [
		{
			name: '{icon}',
			resolve: ({ icon }) => ({ class: `material-symbols-outlined`, content: icon }),
		},
	],
})

export default {
	breakpoints: {
		thresholds: {
			xs: 320,
			sm: 480,
			md: 800,
			lg: 1024,
		},
	},
	colors: {
		variables: {
			black: '#000',
			white: '#fff',
			primary: '#d40000',
			danger: '#ff0000',
			success :'#00ff00',
			backgroundPrimary: '#ffffff',
			textPrimary: '#000000',

			'neutral-100': '#f6f6f6',
			'neutral-350': '#b1b1b1',
			'neutral-400': '#a3a3a3',
			'neutral-500': '#797979',
			'neutral-700': '#333333',
			'red-100': '#fde5e5',
			'red-300': '#ffaaaa',
			'red-450': '#ff5555',
			'red-600': '#d40000',
			'green-100': '#e2ffed',
			'green-300': '#6AF19B',
			'green-600': '#0aaf47',
			'blue-100': '#E0EBFF',
			'blue-300': '#B4CEFF',
			'blue-400': '#689DFF',
			'yellow-100': '#fffbe6',
			'yellow-600': '#ffd400',
		},
		threshold: 170,
	},
	components: {
		VaButton: {
			style: { '--va-button-border-radius': '16px' },
		},
	},
	fontFamily: {
		sans: ['Lufga Regular', 'sans-serif'],
	},
	fontSize: {
		'2xs': ['10px', { lineHeight: '12px'}],
		xs: ['12px', { lineHeight: '14px'}],
		sm: ['14px', { lineHeight: '18px'}],
		md: ['16px', { lineHeight: '18px'}],
		lg: ['18px', { lineHeight: '24px'}],
		xl: ['24px', { lineHeight: '30px'}],
		'2xl': ['28px', { lineHeight: '36px'}],
		'3xl': ['36px', { lineHeight: '44px'}],
	},
	icons: iconsConfig,
}
